import React from 'react';
import { Chip, ChipProps } from '@mui/material';
import { TrackType, TRACK_TYPE_LABELS } from '../../constants/trainingConstants';

interface TrackTypeBadgeProps {
  trackType: TrackType | 'kb' | 'playbook';
  size?: ChipProps['size'];
}

/**
 * Track type is the one categorical pair that carries a fixed hue, by owner
 * decision (2026-09-14): admins scan long track and session lists by type.
 * Knowledge Base = info, Sales Playbook = signature tint. Both come from the
 * palette; no third type gets a new colour without a token to back it.
 */
export const TRACK_TYPE_TONE: Record<TrackType, 'info' | 'signature'> = {
  [TrackType.KB]: 'info',
  [TrackType.PLAYBOOK]: 'signature',
};

const TONE_SX = {
  info: { bgcolor: 'var(--info-tint)', color: 'var(--info)', borderColor: 'var(--info)' },
  signature: { bgcolor: 'var(--signature-tint)', color: 'var(--signature)', borderColor: 'var(--signature)' },
} as const;

const TrackTypeBadge: React.FC<TrackTypeBadgeProps> = ({ trackType, size = 'small' }) => {
  const type = trackType as TrackType;
  const tone = TRACK_TYPE_TONE[type];
  return (
    <Chip
      label={TRACK_TYPE_LABELS[type] || trackType}
      variant="outlined"
      size={size}
      data-testid={`track-type-${type}`}
      data-track-type={type}
      data-tone={tone}
      sx={{ fontWeight: 500, ...(tone ? TONE_SX[tone] : {}) }}
    />
  );
};

export default TrackTypeBadge;
